export default "__VITE_ASSET__07152824__"